import { render, staticRenderFns } from "./b-menu-breadcrumb.vue?vue&type=template&id=1d248aec&scoped=true&"
import script from "./b-menu-breadcrumb.vue?vue&type=script&lang=js&"
export * from "./b-menu-breadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-breadcrumb.vue?vue&type=style&index=0&id=1d248aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d248aec",
  null
  
)

export default component.exports